// Feature flags. Flip these to re-enable a feature.
// Keep this file dependency-free — it's imported by many components.

/**
 * Loyalty rewards (earn/redeem points).
 * Temporarily off until the Clover POS integration is live so the two
 * point ledgers can't drift. Existing point balances remain in the DB.
 */
export const LOYALTY_ENABLED = false;

/**
 * Online ordering (cart + checkout).
 * When false, the Menu becomes a display-only page: no "Add" buttons,
 * no cart icon, /cart and /checkout redirect back to /menu.
 * Turn back on when we're ready to accept online orders.
 */
export const ONLINE_ORDERING_ENABLED = true;

/**
 * Show item prices on the public storefront (menu grid, featured carousel,
 * landing menu preview). Admin dashboards ALWAYS see prices — this flag
 * only affects the customer-facing site.
 */
export const SHOW_PRICES = true;
